import React from 'react';
import Select from 'react-select';
import constants from '../../Constants';

const getKeyFromValue = (obj, value) => {
    for (const k of Object.keys(obj)) {
        if (obj[k].indexOf(value) !== -1) {
            return k;
        }
    }

    return '';
};

const ChooseCategory = props => {
    const key = getKeyFromValue(props.options, props.filename);
    const nb = key ? props.options[key].length : 0;
    const selected = key ? props.options[key].indexOf(props.filename) : -1;

    return (
        <React.Fragment>
            <div className="form-group">
                <label>Choisir un produit</label>
                <Select
                    options={Object.keys(props.options)
                        .sort((a, b) => a.localeCompare(b))
                        .map(f => ({
                            label: f,
                            value: f
                        }))}
                    onChange={e => props.handleSelectOption(e.value)}
                    value={{
                        label: key,
                        value: key
                    }}
                />
            </div>
            <div className="form-group">
                <label htmlFor="sub">Sous-Titre</label>
                <input
                    type="text"
                    name="subtitle"
                    value={props.subtitle}
                    onChange={e => props.handleSetSub(e.target.value)}
                    className="form-control"
                />
            </div>
            {!key || (
                <div
                    className="controls"
                    style={{
                        display: nb > 1 ? 'block' : 'none'
                    }}
                >
                    <p>
                        Sélectionnez une image <i className="fa fa-angle-double-right ip5" />
                    </p>
                    <div>
                        {props.options[key].map((f, i) => (
                            <img
                                className={i === selected ? 'fruitSelection active' : 'fruitSelection'}
                                key={f}
                                src={`${constants.cloud_storage}/Assets/Library/Bakery/${f}`}
                                onClick={() => props.handleSwitchOption(i, key)}
                                height="100"
                                alt="bakery"
                            />
                        ))}
                    </div>
                    <hr className="visible-xs" style={{ marginBottom: '-10px' }} />
                </div>
            )}
        </React.Fragment>
    );
};

export default ChooseCategory;
